import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
export default function (_x, _x2) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, inject) {
    var icons, getIcon;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          icons = {
            "64x64": "/_nuxt/icons/icon_64x64.16e68c.png",
            "120x120": "/_nuxt/icons/icon_120x120.16e68c.png",
            "144x144": "/_nuxt/icons/icon_144x144.16e68c.png",
            "152x152": "/_nuxt/icons/icon_152x152.16e68c.png",
            "192x192": "/_nuxt/icons/icon_192x192.16e68c.png",
            "384x384": "/_nuxt/icons/icon_384x384.16e68c.png",
            "512x512": "/_nuxt/icons/icon_512x512.16e68c.png",
            "ipad_1536x2048": "/_nuxt/icons/splash_ipad_1536x2048.16e68c.png",
            "ipadpro9_1536x2048": "/_nuxt/icons/splash_ipadpro9_1536x2048.16e68c.png",
            "ipadpro10_1668x2224": "/_nuxt/icons/splash_ipadpro10_1668x2224.16e68c.png",
            "ipadpro12_2048x2732": "/_nuxt/icons/splash_ipadpro12_2048x2732.16e68c.png",
            "iphonese_640x1136": "/_nuxt/icons/splash_iphonese_640x1136.16e68c.png",
            "iphone6_50x1334": "/_nuxt/icons/splash_iphone6_50x1334.16e68c.png",
            "iphoneplus_1080x1920": "/_nuxt/icons/splash_iphoneplus_1080x1920.16e68c.png",
            "iphonex_1125x2436": "/_nuxt/icons/splash_iphonex_1125x2436.16e68c.png",
            "iphonexr_828x1792": "/_nuxt/icons/splash_iphonexr_828x1792.16e68c.png",
            "iphonexsmax_1242x2688": "/_nuxt/icons/splash_iphonexsmax_1242x2688.16e68c.png"
          };
          getIcon = function getIcon(size) {
            return icons[size + 'x' + size] || '';
          };
          inject('icon', getIcon);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}